import { createFileRoute, Navigate } from "@tanstack/react-router";
import { MentionsInbox } from "@/components/app/mentions/mentions-inbox";
import { useMessagingAvailable } from "@/lib/messaging/notices/available";

export const Route = createFileRoute("/_authenticated/_communications/mentions/")({
  component: MentionsPage,
});

/** Mentions live in the messaging section; someone without messaging keeps this page. */
function MentionsPage() {
  if (useMessagingAvailable()) return <Navigate to="/messaging/mentions" replace />;
  return <MentionsInbox />;
}
